class StoffaPicker extends HTMLElement {
  constructor() {
    super();
    this.coloreSelect = this.querySelector('[data-stoffa-colore]');
    this.numeroSelect = this.querySelector('[data-stoffa-numero]');
    this.preview = this.querySelector('[data-stoffa-preview]');
    this.image = this.querySelector('[data-stoffa-image]');
    this.dialog = this.querySelector('[data-stoffa-dialog]');
    this.dialogImage = this.querySelector('[data-stoffa-dialog-image]');
    this.zoomButton = this.querySelector('[data-stoffa-zoom]');
    this.closeButton = this.querySelector('[data-stoffa-close]');

    if (this.coloreSelect) {
      this.coloreSelect.addEventListener('change', this.onColoreChange.bind(this));
    }
    if (this.zoomButton && this.dialog) {
      this.zoomButton.addEventListener('click', () => this.dialog.showModal());
    }
    if (this.closeButton && this.dialog) {
      this.closeButton.addEventListener('click', () => this.dialog.close());
    }
    if (this.dialog) {
      // Clicking the backdrop (the dialog element itself, outside its content) closes it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    this.onColoreChange();
  }

  onColoreChange() {
    if (!this.coloreSelect || !this.numeroSelect || !this.preview) return;

    const option = this.coloreSelect.selectedOptions[0];
    const count = option ? parseInt(option.dataset.count, 10) || 0 : 0;

    if (!count) {
      this.preview.hidden = true;
      // Nascosto e disattivato: la fantasia e' obbligatoria, ma finche' non c'e'
      // un colore il campo non esiste davvero e non deve bloccare l'invio.
      this.numeroSelect.disabled = true;
      this.numeroSelect.innerHTML = '';
      return;
    }

    this.numeroSelect.disabled = false;

    const imageUrl = option.dataset.image || '';
    const alt = `Tonalità di ${option.value}`;
    if (this.image) {
      this.image.src = imageUrl;
      this.image.alt = alt;
    }
    if (this.dialogImage) {
      this.dialogImage.src = imageUrl;
      this.dialogImage.alt = alt;
    }

    // Rebuild the pattern list, keeping the current choice when it still exists.
    const previous = this.numeroSelect.value;
    this.numeroSelect.innerHTML = '';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Seleziona...';
    this.numeroSelect.appendChild(placeholder);

    for (let i = 1; i <= count; i++) {
      const opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = `Fantasia ${i}`;
      this.numeroSelect.appendChild(opt);
    }

    if (previous && parseInt(previous, 10) <= count) {
      this.numeroSelect.value = previous;
    }

    this.preview.hidden = false;
  }
}

customElements.define('stoffa-picker', StoffaPicker);
